import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["classes", "label", "fieldName", "isToggleButtonHidden", "autoComplete", "validate", "invalid", "id", "showInvalid"];
import React from "react";
import { string, bool, shape, func } from "prop-types";
import { usePassword } from "@magento/peregrine/lib/talons/Password/usePassword";
import Button from "../Button";
import { isRequired } from "../../util/formValidators";
import Icon from "../../../../components/Icon";
import { SimpleField } from "@Components/FormFields/SimpleField";
const Password = props => {
  const {
      classes: propClasses,
      label,
      fieldName,
      isToggleButtonHidden,
      autoComplete,
      validate,
      invalid,
      id,
      showInvalid
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const talonProps = usePassword();
  const {
    visible,
    togglePasswordVisibility
  } = talonProps;
  const passwordButton = /*#__PURE__*/React.createElement(Button, {
    className: "uk-form-icon uk-form-icon-flip",
    onClick: togglePasswordVisibility,
    type: "button"
  }, visible ? /*#__PURE__*/React.createElement(Icon, {
    name: "icon-visible"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "icon-hidden"
  }));
  const fieldType = visible ? "text" : "password";
  return /*#__PURE__*/React.createElement(SimpleField, _extends({
    before: !isToggleButtonHidden && passwordButton,
    autoComplete: autoComplete,
    name: fieldName,
    type: fieldType,
    validate: validate,
    label: label,
    id: id,
    invalid: invalid,
    showInvalid: showInvalid
  }, otherProps));
};
Password.propTypes = {
  autoComplete: string,
  classes: shape({
    root: string
  }),
  label: string,
  fieldName: string,
  isToggleButtonHidden: bool,
  validate: func,
  id: string
};
Password.defaultProps = {
  isToggleButtonHidden: true,
  validate: isRequired
};
export default Password;